module.exports = __webpack_public_path__ + "img/ableton-live-set-screenshot-dim-75.d6502e5d.png";